<template>
  <div id="step-2" class="multi-step-form active-step">
    <div class="d-flex align-content-center">
      <p>
        <img src="@/assets/arrow-left.svg" alt="OK" @click="prevEtapa()" />
      </p>
    </div>
    <div
      class="d-flex align-content-center align-flex-title"
      style="margin-top: -55px"
    >
      <p>Vamos iniciar a simulação do seu plano de saúde?</p>
    </div>
    <div class="align-flex-title">
      <h3>Você é um servidor público?</h3>
    </div>
    <div class="row align-flex-title input-field-simulador">
      <b-button @click="setEtapa('step-3-alt')" style="margin-left: 0px">
        Sim
      </b-button>
      <b-button @click="setEtapa('step-3')">Não</b-button>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import buscarConveniosAPI from "@/services/buscarConvenios";
import buscarEntidadesAPI from "@/services/buscarEntidadesAPI";

export default {
  name: "StepDois",
  mounted() {
    document.getElementById("step-progress").value = 6.67 * 1;
    document
      .getElementById("step-progress-point1")
      .classList.add("rounded-point-progress-ok");
  },
  computed: {
    estadoid() {
      return store.getters.getAliancaEstadoID;
    },
  },
  methods: {
    prevEtapa() {
      store.commit("mutAliancaProxEtapa", "step-1");
    },
    async setEtapa(etapa) {
      store.commit("mutSimuleAquiLoader", true);

      if (etapa == "step-3-alt") {
        store.commit("mutAliancaProxEtapa", etapa);

        await this.getOrgaos();
      }

      // } else {
      //   store.commit("mutAliancaProxEtapa", etapa);

      //   await this.getEntidadesClasse();
      // }

      document.getElementById("step-progress").value = 6.67 * 2;
      store.commit("mutSimuleAquiLoader", false);
    },
    async getOrgaos() {
      store.commit("mutSimuleAquiOrgaos", []);

      let options_orgaos = await buscarConveniosAPI(this.estadoid);

      options_orgaos = options_orgaos.map((el) => {
        return {
          id: el.slug,
          name: el.OrgaoNome.replace("&#8211;", "-"),
        };
      });

      options_orgaos = options_orgaos.sort((a, b) => {
        let result = 0;

        if (a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase()) {
          result = 1;
        } else {
          result = -1;
        }

        return result;
      });

      store.commit("mutSimuleAquiOrgaos", options_orgaos);
    },
    async getEntidadesClasse() {
      store.commit("mutSimuleAquiEntidades", []);

      let options_entidades = await buscarEntidadesAPI(this.estadoid);

      options_entidades = options_entidades.map((el) => {
        return {
          id: el.slug,
          name: el.EntidadeNome.replace("&#8211;", "-"),
        };
      });

      options_entidades = options_entidades.sort((a, b) => {
        let result = 0;

        if (a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase()) {
          result = 1;
        } else {
          result = -1;
        }

        return result;
      });

      store.commit("mutSimuleAquiEntidades", options_entidades);
    },
  },
};
</script>